export default function getAndroidVersionFromUserAgent() {
    let androidVersion;
    if (typeof window !== 'undefined') {
        const { userAgent } = window.navigator;
        if (userAgent.indexOf("Android") >= 0 ) {
            androidVersion = parseFloat(userAgent.slice(userAgent.indexOf("Android") + 8));
        }
    }
    return androidVersion;
};


// WEBPACK FOOTER //
// ./app/lib/util/getAndroidVersionFromUserAgent.js